<template>
  <div class="overview__project">
    <div v-if="listView" class="folders__heading">
      <span class="heading__text">{{ projectHeader }}:</span>
      <span class="heading__text">{{ dateHeader }}:</span>
      <span class="heading__text"
        >{{ $t('shared.label.preferred_deadline') }}:</span
      >
      <span class="heading__text">{{ $t('shared.label.from') }}:</span>
      <span class="heading__text">{{ $t('shared.label.to') }}:</span>
      <span class="heading__text heading__text"
        >{{ $t('shared.label.progress') }}:</span
      >
    </div>
    <slot />
  </div>
</template>
<script setup>
import i18n from '@/i18n'
import { $cookies } from '@/main'
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const $t = i18n.t

const showListView = computed(() => store.state.account.showListView)
const showSupplierListView = computed(
  () => store.state.account.showSupplierListView
)
const isCustomer = computed(() => $cookies.get('userType') !== 'supplier')

const projectHeader = computed(() =>
  isCustomer.value ? $t('shared.label.project') : $t('shared.label.task')
)

const dateHeader = isCustomer.value
  ? $t('shared.label.date')
  : $t('shared.label.deadline')

const isSupplier = computed(() => $cookies.get('userType') === 'supplier')
const listView = computed(() =>
  isSupplier.value ? showSupplierListView.value : showListView.value
)
</script>
<style lang="scss" scoped>
.overview__project {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20.875rem, 1fr));
  grid-auto-rows: auto;
  grid-auto-flow: row dense;
  grid-column-gap: 1.25rem;
  grid-row-gap: 1.25rem;
  @include tabletPortrait {
  }
}

.folders__heading {
  background: #eef0f6;
  display: grid;
  font-size: 14px;
  grid-template-columns: repeat(10, 1fr) 20px;
  grid-template-rows: auto;
  padding: 10px 20px;
  border-radius: 5px;
  grid-column-gap: 20px;
  .heading__text {
    color: #767c98;
    display: block;
    &:nth-child(1) {
      grid-column: 1 / span 3;
    }
    &:nth-child(2) {
      grid-column: 4 / span 1;
    }
    &:nth-child(3) {
      grid-column: 5 / span 2;
    }
    &:nth-last-child(1) {
      display: flex;
      justify-content: center;
      grid-column: 9 / span 2;
    }
  }
}

.grid-container--list-view {
  .overview__project {
    grid-template-columns: 1fr;
    grid-row-gap: 0.625rem;
  }
}
</style>
